$.fn.readMore = function(options) {
  let self = this;
  let container = self.closest('.text-content');
  let extended_content = self.closest('p').find("~ *").wrapAll("<div class='read-more-wrap'></div>").parent();
  extended_content.wrapInner( "<div class='read-more-wrap__sizer text-content'></div>");
  self.removeAttr('href');
  self.closest('p').before(extended_content);
  self.wrapInner( "<span class='open'></span>");
  $( '<span class="close">Réduire</span>' ).appendTo( self );

  self.click(function() {
    extended_content.css('--height', extended_content.find('.read-more-wrap__sizer').outerHeight()+ 'px');
    extended_content.toggleClass('read-more-wrap--open');
    self.toggleClass('btn-read-more--open');
  });

  return function() {
    return self
  }()
}
